import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import type { GroupType } from '@lebinatikra/shared-types';

const GROUP_TYPES: GroupType[] = ['class', 'staff', 'cohort', 'custom'];

interface GroupFormValues {
  name: string;
  type: GroupType;
}

export function GroupCreate() {
  const { t } = useTranslation();
  const { organizationId } = useParams();
  const { formProps, saveButtonProps } = useForm<GroupFormValues>({
    resource: 'groups',
    action: 'create',
    redirect: 'list',
    meta: { parentId: organizationId },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" initialValues={{ type: 'class' }}>
        <Form.Item name="name" label={t('common.name')} rules={[{ required: true, max: 200 }]}>
          <Input />
        </Form.Item>
        <Form.Item name="type" label={t('fields.type')} rules={[{ required: true }]}>
          <Select options={GROUP_TYPES.map((g) => ({ value: g, label: g }))} />
        </Form.Item>
      </Form>
    </Create>
  );
}
